const indexItems = [
  { id: 1, label: '悬疑探案', count: 156, icon: 'ri-search-eye-line', color: 'primary' },
  { id: 2, label: '都市情感', count: 203, icon: 'ri-heart-line', color: 'accent' },
  { id: 3, label: '古装传奇', count: 178, icon: 'ri-vip-crown-line', color: 'secondary' },
  { id: 4, label: '科幻奇幻', count: 94, icon: 'ri-rocket-line', color: 'primary' },
  { id: 5, label: '喜剧搞笑', count: 132, icon: 'ri-emotion-laugh-line', color: 'accent' },
  { id: 6, label: '动作冒险', count: 115, icon: 'ri-flashlight-line', color: 'secondary' },
  { id: 7, label: '爱情文艺', count: 87, icon: 'ri-movie-line', color: 'primary' },
  { id: 8, label: '纪录片', count: 63, icon: 'ri-earth-line', color: 'accent' },
  { id: 9, label: '动画动漫', count: 141, icon: 'ri-palette-line', color: 'secondary' },
];

const colorMap: Record<string, { bg: string; text: string; iconBg: string }> = {
  primary: { bg: 'bg-primary-100', text: 'text-primary-700', iconBg: 'bg-primary-100' },
  accent: { bg: 'bg-accent-100', text: 'text-accent-700', iconBg: 'bg-accent-100' },
  secondary: { bg: 'bg-secondary-100', text: 'text-secondary-700', iconBg: 'bg-secondary-100' },
};

const iconColorMap: Record<string, string> = {
  primary: 'text-primary-500',
  accent: 'text-accent-500',
  secondary: 'text-secondary-500',
};

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-4">
            <i className="ri-grid-line"></i>
            分类索引
          </div>
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mb-3">
            影视分类
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            按类型快速定位你感兴趣的内容，覆盖妖精视频、桃花视频等平台全品类资源
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 gap-4 md:gap-5 max-w-4xl mx-auto">
          {indexItems.map((item) => {
            const colors = colorMap[item.color];
            const iconClr = iconColorMap[item.color];
            return (
              <div
                key={item.id}
                className={`${colors.bg} rounded-xl p-5 md:p-6 cursor-pointer hover:scale-[1.03] transition-transform`}
              >
                <div className={`w-10 h-10 rounded-xl flex items-center justify-center mb-3 ${iconClr}`}>
                  <i className={`${item.icon} text-lg`}></i>
                </div>
                <h3 className="text-foreground-950 font-medium text-sm md:text-base mb-1">
                  {item.label}
                </h3>
                <p className={`${colors.text} text-xs`}>
                  {item.count} 部资源
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}